export default __webpack_public_path__ + "0eb6d6931c431321b35d7ecfeff80355.svg";